import React, { Component }   from 'react'
import PropTypes              from 'prop-types'
import { Route, Switch }      from 'react-router-dom'
import without                from 'lodash.without'
import union                  from 'lodash.union'
import NoResult               from '../../components/NoResult'
import MajorItem              from '../../components/MajorItem/indexNew'
import Search                 from '../../components/Search'
import Toast                  from '../../components/Toast'
import { getMajors }          from '../../api/major'
import Classify               from '../Major/List/Classify'
import { TYPE_UNDERGRADUATE } from '../Major/constants'
import Category               from '../Major/List/Catgory'
import OperationBtn2           from './OperationBtn2'
import { LIMIT }              from '../constants'
import '../Major/List/index.less'
import './Choose.less';

const paramReset = {
  limit: LIMIT,
  page: 1,
  _s_type: null,
  _s_category_id: null,
  _s_classifiy_id: null,
  _s_name: null,
}

class MajorList extends Component {

  static propTypes = {
    codes: PropTypes.array,
    changeCodes: PropTypes.func,
  }

  state = {
    searchVal: '',
    lastPage: false,
    searchResult: [],
    param: paramReset,
    loading: false,
    showToast: false,
    toastIcon: 'success',
    toastText1: '',
    toastText2: '',
  }

  searchInput = null

  handleSearch(value) {
    const param = {
      _s_type: TYPE_UNDERGRADUATE,
      _s_name: value,
    }
    this.setState({
      searchVal: value,
      loading: Boolean(value),
    })
    if (value) {
      getMajors(param).then(res => {
        this.setState({
          searchResult: res.data,
          lastPage: res.lastPage,
        })
      }).finally(() => {
        this.setState({
          loading: false,
        })
      })
    }
  }

  handleResetSearch() {
    const { history } = this.props
    this.searchInput.reset()
    history.push(`/majorwishlist/choose`)
  }

  handleBack() {
    const { history } = this.props
    history.push(`/majorwishlist`)
  }

  handleMajorClick(major) {
    const { history } = this.props
    history.push(`/majorwishlist/major/${major.id}`)
  }

  renderSearchResult() {
    const { searchResult } = this.state
    if (Array.isArray(searchResult) && searchResult.length) {
      return (
        <div className="major-list-outter search-result">
          <div className='search-title'>搜索结果</div>
          {searchResult.map((d, i) =>
            <MajorItem
              key={i}
              major={d}
              // onClick={onMajorClick}
              rightIcon={this.renderRightIcon.bind(this)}
            />
          )}
          <div className="search-bottom">已加载所有结果</div>
        </div>
      )
    } else {
      return <NoResult
        prompt1="对不起"
        prompt2="没有匹配到合适的专业哦"
        resetBtnText="重新搜索"
        onResetSearch={this.handleResetSearch.bind(this)}
      />
    }
  }

  handleModifyMajor(data, selected, e) {
    const { codes } = this.props
    const modify = data.code
      ? [data.code]
      : data.children.map(d => d.code)
    const newCodes = selected
      ? without(codes, ...modify)
      : union(codes, modify)
    this.setState(() => {
      return {
        showToast: true,
        toastIcon: selected ? 'deleted' : 'success',
        toastText1: selected ? '已删除' : '已添加',
        toastText2: data.name,
      }
    })
    this.props.changeCodes(newCodes)
    e.stopPropagation()
  }

  renderRightIcon(data) {
    const { codes } = this.props
    let selected = false
    if (data.code) {
      selected = codes.includes(data.code)
    } else {
      selected = data.children.every(d => codes.includes(d.code))
    }
    return <OperationBtn2 added={selected} onClick={this.handleModifyMajor.bind(this, data, selected)}/>
  }

  render() {
    const { match } = this.props
    const {
      searchVal,
      loading,
      showToast,
      toastIcon,
      toastText1,
      toastText2
    } = this.state
    return (
      <div className="major-list-wrapper major-wish-list-wrapper">
        <Search
          ref={ref => this.searchInput = ref}
          placeholder="搜索你想了解的专业"
          onSearch={this.handleSearch.bind(this)}
        />
        {searchVal && !loading
          ? this.renderSearchResult()
          : <div className="major-list-outter">
            <Switch>
              <Route
                path={`${match.url}/:id`}
                render={props => <Classify {...props} onMajorClick={this.handleMajorClick.bind(this)}
                                           rightIcon={this.renderRightIcon.bind(this)}/>}
              />
              <Route
                path={`${match.url}/`}
                component={Category}
              />
            </Switch>
          </div>
        }
        <div className="bottom-btn">
          <button className="primary full" onClick={this.handleBack.bind(this)}>返回意向专业清单</button>
        </div>
        <Toast show={showToast} icon={toastIcon} onHide={() => this.setState({ showToast: false })}>
          <i>{toastText1}</i>
          <p>{toastText2}</p>
        </Toast>
      </div>
    )
  }
}


export default MajorList



// WEBPACK FOOTER //
// ./src/pages/MajorWishList/Choose.js